<template>
  <PageTemplate>
    <h6 class="element-header">
      {{ $t('calendar.title') }}
    </h6>
    <Loader v-if="!isLoaded"/>
    <div class="row tui-calendar-css">
      <div class="col-lg-2">

        <!-- NEW MEETING BUTTON -->
        <div class="lnb-new-schedule">
          <button class="btn btn-primary btn-block lnb-new-schedule-btn"
                  :onclick="() => showEventModal = true">
            {{ $t('calendar.new_appointment') }}
          </button>
        </div>

        <!-- CHECKBOXES -->
        <div class="custom-lnb-calendars-item pl-3 pt-3 pb-0">
          <div class="custom-lnb-calendars-item form-group pb-0 py-2 mb-0">
            <label>
              <input :checked="checkboxes.remoteTermin" name="remoteTermin"
                     :onchange="handleCheckboxesOptions"
                     class="tui-full-calendar-checkbox-square mr-2 align-middle" type="checkbox">
              <span></span>
              <strong>{{ $t('calendar.remote_appointments_display') }}</strong>
            </label>
          </div>
          <div class="custom-lnb-calendars-item form-group pb-0 py-2 mb-0">
            <label>
              <input :checked="checkboxes.personalTermin" name="personalTermin"
                     :onchange="handleCheckboxesOptions"
                     class="tui-full-calendar-checkbox-square mr-2 align-middle" type="checkbox">
              <span></span>
              <strong>{{ $t('calendar.personal_appointments_display') }}</strong>
            </label>
          </div>
          <div class="custom-lnb-calendars-item form-group pb-0 py-2 mb-0">
            <label>
              <input :checked="checkboxes.allLocations" name="allLocations"
                     :onchange="handleCheckboxesOptions"
                     class="tui-full-calendar-checkbox-square mr-2 align-middle" type="checkbox">
              <span></span>
              <strong>{{ $t('calendar.all_locations_display') }}</strong>
            </label>
          </div>
        </div>

        <!-- SEARCH AND LOCATIONS (meeting rooms) -->
        <div class="border-top pt-3 mt-2">
          <!-- Search input -->
          <input id="searchCalendar" class="form-control" :placeholder="$t('general.button.search')"
                 @input="handleInputOffices">

          <!-- Locations and meeting rooms -->
          <div class="lnb-calendars-d1 pretty-scrollbar mt-3 bg-white rounded">
            <div v-for="office in officeListComputed" :key="office.id" class="lnb-calendars-item">
              <label>
                <input type="checkbox" :checked="office?.checked" :name="office?.name" :value="office.id"
                       class="d-none tui-full-calendar-checkbox-round"
                       @change="(e) => handleOfficeList(e, office?.id, undefined, office.meetingRooms)">
                <span
                    :style="{ backgroundColor: office?.checked ? office?.colorCode : 'transparent', borderColor: office?.colorCode }"></span>
                {{ office.name }}
              </label>
              <div v-for="meeting in office.meetingRooms" :key="meeting.id" class="lnb-calendars-item pl-4">
                <label>
                  <input type="checkbox" :checked="meeting?.checked" :name="meeting.name" :value="meeting.id"
                         class="d-none tui-full-calendar-checkbox-round"
                         @change="(e) => handleOfficeList(e, office?.id, meeting?.id, office.meetingRooms)">
                  <span
                      :style="{ backgroundColor: meeting?.checked ? meeting.colorCode : 'transparent', borderColor: meeting.colorCode }"></span>
                  - {{ meeting.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-10 position-static mt-4 mt-lg-0 pb-5 pb-lg-0">
        <div class="view-selector form-group px-0 d-lg-flex justify-content-between align-items-center">
          <div class="d-flex flex-wrap" :style="{ gap: '12px' }">
            <!-- VIEW OPTIONS (weekly, monthly, daily) -->
            <div class="dropdown" ref="dropdownRef">
              <button class="btn btn-default btn-sm dropdown-toggle h-100 d-flex align-items-center"
                      @click="toggleDropdown"
                      style="border-radius: 6px !important;">
                <div :class="selectedClass" class="icon"></div>
                {{ selectedTitle }}
              </button>
              <ul v-if="showDropdown" class="dropdown-menu show">
                <li v-for="option in CalendarViewOptions" :key="option.value" @click="changeView(option.value)"
                    class="dropdown-item">
                  <div :class="option.class" class="icon"></div>
                  {{ option.title }}
                </li>
              </ul>
            </div>

            <!-- NAVIGATION BUTTONS -->
            <div>
              <button @click="setShowedDate"
                      class="btn btn-default btn-sm move-today rounded">
                {{ $t('general.today') }}
              </button>
              <button @click="movePrev" class="btn btn-default btn-sm move-day ml-1 rounded"
                      data-action="move-prev">
                <i class="os-icon os-icon-chevron-left" data-action="move-prev"></i>
              </button>
              <button @click="moveNext" class="btn btn-default btn-sm move-day ml-1 rounded"
                      data-action="move-next">
                <i class="os-icon os-icon-chevron-right" data-action="move-next"></i>
              </button>
            </div>

            <div class="d-flex align-items-center font-weight-bolder">
              <div class="mb-0">{{ formatDate(showedDate) }}</div>
              <div v-if="selectedView === 'week'" class="mb-0">&nbsp; - &nbsp;{{
                  formatDate(moment(showedDate).add(7,
                      'days'), 'DD.MM')
                }}
              </div>
            </div>
          </div>


          <!-- USER DROPDOWN -->
          <div class="d-flex align-items-center col-lg-4 col px-0 mt-3 mt-lg-0">
            <label for="employes" class="mr-2 mb-0">{{ t('general.employee') }}</label>
            <Selectvue classFormGroup="mb-0 w-100" v-model="selectedUser" :options="userDropdown"
                       @update:selected="selectedUser = $event"/>
          </div>
        </div>

        <!-- CALENDAR ELEMENT -->
        <div ref="calendarRef" class="calendar"></div>

        <!-- EVENT DETAILS POPUP -->
        <div v-if="showEventPopup" ref="eventPopupRef" class="event-popup rounded"
             :style="{ top: selectedEvent.top, left: selectedEvent.left }">
          <div class="tui-full-calendar-popup-top-line" :style="{ backgroundColor: selectedEvent?.backgroundColor }">
          </div>
          <div class="tui-full-calendar-popup-container">
            <h6>{{ selectedEvent.title }}</h6>
            <p>{{ selectedEvent.startFormated }} - {{ selectedEvent.endFormated }}</p>
            <p>
              <i class="os-icon os-icon-home"></i>
              {{ selectedEvent.location }}
            </p>
            <p v-if="selectedEvent.coachNames">
              <i class="os-icon os-icon-user"></i>
              {{ selectedEvent.coachNames }}
            </p>
            <p v-if="selectedEvent.unemployedNames">
              <i class="os-icon os-icon-search"></i>
              {{ selectedEvent.unemployedNames }}
            </p>
            <p v-if="selectedEvent.meetingRoom">
              <i class="os-icon os-icon-map-pin"></i>
              {{ selectedEvent.meetingRoom }}
            </p>

            <div class="border-top d-flex pt-2">
              <div v-if="selectedEvent.hisMeeting" @click="editEvent" class="mx-2 cursor-pointer">
                <i style="color: blue" class="os-icon os-icon-edit-2"></i>
                {{ t('general.button.edit') }}
              </div>
              <div v-if="selectedEvent.hisMeeting" @click="showDeleteEventModal" class="mx-2 cursor-pointer">
                <i style="color: red" class="os-icon os-icon-trash-2"></i>
                {{ t('general.button.delete') }}
              </div>

              <div @click="closeEventPopup" class="mx-2 cursor-pointer">
                <i style="color: orange; font-size: 12px" class="os-icon os-icon-close"></i>
                Schließen
              </div>
            </div>
          </div>
          <!-- <div id="tui-full-calendar-popup-arrow" class="tui-full-calendar-popup-arrow tui-full-calendar-arrow-left">
            <div class="tui-full-calendar-popup-arrow-border">
              <div class="tui-full-calendar-popup-arrow-fill"></div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- MODALS -->
    <Modal v-model="showEventModal"
           :onSave="submitForm"
           :sizeModal="'modal-md'"
           classFooter="justify-content-center"
           :title="t('calendar.modal_event_title')">

      <BaseInput placeholder="Title"
                 :validation="v$.title"
                 :messages="v$.title.required.$message"
                 label="Title"
                 :required="true"
                 v-model="modalData.title"/>

      <Selectvue :options="calendarMeetingTypes"
                 @update:modelValue="meetingTypeValidator"
                 :required="true"
                 label="Terminart"
                 :validation="v$.meetingType"
                 :messages="v$.meetingType?.required?.$message"
                 v-model="modalData.meetingType"/>

      <Selectvue v-model="modalData.locationId"
                 :disabled="modalData.meetingType === 'private_meeting'"
                 :options="officeListBackup"
                 :validation="v$.locationId"
                 :messages="v$.locationId?.required?.$message"
                 label="Standort"
                 :is-clear="true"
                 @update:modelValue="updateLocation"/>

      <BaseCheckbox :classLabel="'w-auto ml-2'" :required="true"
                    :classFormGroup="'d-flex align-items-center justify-content-end flex-row-reverse'"
                    :label="'Externer Termin bzw. kein BSG-Raum wird benötigt'" v-model="modalData.isRemote"
                    :validation="v$.isRemote"
                    :messages="v$.isRemote.required.$message"
                    @update:modelValue="updateMeeting"/>

      <Selectvue v-model="modalData.meetingRoomId"
                 :disabled="modalData.isRemote || modalData.meetingType === 'private_meeting'"
                 :options="dropdowns.meetingRoomId"
                 :is-clear="true" label="Raum"
                 :validation="v$.meetingRoomId"
                 :messages="v$.meetingRoomId.required?.$message"/>

      <Selectvue v-model="modalData.coachIds"
                 :disabled="modalData.meetingType === 'private_meeting'"
                 :isMulti="true"
                 :options="dropdowns.coachesIds"
                 :is-clear="true"
                 label="Teilnehmer von BSG"
                 :validation="v$.coachIds"
                 :messages="v$.coachIds.required?.$message"/>

      <Selectvue v-model="modalData.unemployedIds"
                 :disabled="modalData.meetingType === 'private_meeting'"
                 :isMulti="true"
                 :options="dropdowns.unemployedIds"
                 :is-clear="true" label="Kunde"
                 :validation="v$.unemployedIds"
                 :messages="v$.unemployedIds.required?.$message"/>

      <div class="d-flex flex-row flex-md-row justify-content-between"
           :style="{ gap: '8px' }">
        <TuiDatePicker
            :initialDate="modalData.startDate"
            :required="true"
            label="Beginn (Tag/Zeit)"
            @dateChange="handleStartDateChange"/>
        <TuiDatePicker
            :initialDate="modalData.endDate"
            :required="true"
            label="Ende (Tag/Zeit)"
            @dateChange="handleEndDateChange"/>
      </div>
    </Modal>
    <ModalDelete @update:modelValue="showDeleteEvent = $event"
                 :modelValue="showDeleteEvent"
                 :header="t('general.delete_item_header')"
                 :onDelete="deleteEvent"/>

  </PageTemplate>
</template>

<script setup>

import calendarService from '@/api/Calendar';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import TuiDatePicker from '@/components/picker/TuiDatePicker.vue';
import Selectvue from '@/components/SelectVue.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import {formatDate, isColorDark} from '@/shared/functions';
import {calendarMeetingTypes} from '@/shared/utils/calendar/CalendarMeetingTypes';
import {getCalendarViewOptions} from '@/shared/utils/calendar/CalendarViewOptions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaUserStore} from '@/store/piniaUserStore';
import Calendar from '@toast-ui/calendar';
import '@toast-ui/calendar/dist/toastui-calendar.min.css';
import useVuelidate from '@vuelidate/core';
import debounce from 'lodash/debounce';
import moment from 'moment';
import {computed, onMounted, onUnmounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';

const piniaUserState = piniaUserStore();
const CalendarViewOptions = computed(() => getCalendarViewOptions(t));
const getCurrentUser = computed(() => piniaUserState.currentUser.user);
const officeListComputed = computed(() => officeList.value);

const {t, locale} = useI18n();
const calendarRef = ref(null);
const selectedView = ref('week');
const showDropdown = ref(false);
const dropdownRef = ref(null);
const showedDate = ref(new Date());
const showEventPopup = ref(false);
const eventPopupRef = ref(null);
const selectedEvent = ref({});
let locationIds = ref([]);
let meetingRoomIds = ref([]);
const showEventModal = ref(false);
const showDeleteEvent = ref(false);
const calendar = ref(null);
const userDropdown = ref([]);
const selectedUser = ref(getCurrentUser?.value?.id ?? 0);
const officeList = ref([]);
const officeListBackup = ref([]);
const calendarsList = ref([]); // This is important
const isLoaded = ref(false);

const checkboxes = ref({
  remoteTermin: true,
  personalTermin: false,
  allLocations: true,
});

const dropdowns = ref({
  meetingRoomId: [],
  coachesIds: [],
  unemployedIds: [],
});

let modalData = ref({
  title: '',
  locationId: null,
  isRemote: false,
  meetingType: 'client_meeting',
  meetingRoomId: null,
  coachIds: [],
  unemployedIds: [],
  startDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
  endDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
});

const rules = ref({
  title: requiredRule(t),
  meetingType: requiredRule(t),
  isRemote: requiredRule(t),
  startDate: requiredRule(t),
  endDate: requiredRule(t),
  coachIds: requiredRule(t),
  unemployedIds: requiredRule(t),
  meetingRoomId: requiredRule(t),
  locationId: requiredRule(t),
});

const computedRules = computed(() => rules.value);

const v$ = useVuelidate(computedRules, modalData);

const meetingTypeValidator = (meetingType) => {

  switch (meetingType) {

    case 'client_meeting':
      rules.value = {
        ...rules.value,
        coachIds: requiredRule(t),
        unemployedIds: requiredRule(t),
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        locationId: requiredRule(t),
      };
      break;
    case 'group_meeting':
      rules.value = {
        ...rules.value,
        coachIds: requiredRule(t),
        unemployedIds: requiredRule(t),
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        locationId: requiredRule(t),
      };
      break;
    case 'team_meeting':
      rules.value = {
        ...rules.value,
        coachIds: requiredRule(t),
        unemployedIds: '',
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        locationId: requiredRule(t),
      };
      break;
    case 'private_meeting':
      rules.value = {
        ...rules.value,
        coachIds: '',
        unemployedIds: '',
        meetingRoomId: '',
        locationId: '',

      };
      break;
    case 'others':

      rules.value = {
        ...rules.value,
        coachIds: '',
        unemployedIds: '',
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        locationId: requiredRule(t),
      };
      break;
  }
};

async function updateLocation(locationId) {

  if (!locationId) {
    rules.value = {
      ...rules.value,
      meetingRoomId: '',
      unemployedIds: '',
      coachIds: '',
    };
    return;
  }

  const mapper = (list) =>
      list?.map((item) => ({
        label: item.name || item.fullName,
        value: item.id,
      })) || [];

  const dataReset = () => {
    modalData.value.coachIds = [];
    modalData.value.meetingRoomId = null;
    modalData.value.unemployedIds = [];
  };

  if (modalData.value.locationId) {
    clearAllDropdowns();
    dataReset();
  }

  const data = await fetchAllOptions(locationId);

  if (data) {
    const {meetingRoomList, unemployedList, userList} = data;
    dropdowns.value = {
      meetingRoomId: mapper(meetingRoomList),
      coachesIds: mapper(userList),
      unemployedIds: mapper(unemployedList),
    };
  } else {
    clearAllDropdowns();
  }

  switch (modalData.value.meetingType) {
    case 'client_meeting': {
      rules.value = {
        ...rules.value,
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        unemployedIds: requiredRule(t),
        coachIds: requiredRule(t),
      };
    }
      break;
    case 'group_meeting': {
      rules.value = {
        ...rules.value,
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        unemployedIds: requiredRule(t),
        coachIds: requiredRule(t),
      };

      break;
    }
    case 'team_meeting': {
      rules.value = {
        ...rules.value,
        coachIds: requiredRule(t),
        unemployedIds: '',
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        locationId: requiredRule(t),
      };
      break;
    }
    case 'private_meeting': {
      rules.value = {
        ...rules.value,
        unemployedIds: '',
      };
      break;
    }
    case 'others': {
      rules.value = {
        ...rules.value,
        meetingRoomId: modalData.value.isRemote ? '' : requiredRule(t),
        locationId: requiredRule(t),
        coachIds: '',
        unemployedIds: '',

      };
      break;

    }
  }
}

async function updateMeeting(value) {

  switch (modalData.value.meetingType) {
    case 'client_meeting':
      if (value) {
        if (modalData.value.locationId) {
          rules.value = {
            ...rules.value,
            meetingRoomId: '',
            locationId: '',
          };
        } else {
          rules.value = {
            ...rules.value,
            meetingRoomId: '',
            locationId: '',
            unemployedIds: '',
            coachIds: '',
          };
        }
        modalData.value.meetingRoomId = null;
      } else {
        rules.value = {
          ...rules.value,
          meetingRoomId: requiredRule(t),
        };

      }
      break;
    case 'group_meeting':
      if (value) {
        rules.value = {
          ...rules.value,
          meetingRoomId: '',
        };

        modalData.value.meetingRoomId = null;
      } else {
        rules.value = {
          ...rules.value,
          meetingRoomId: requiredRule(t),
        };

      }
      break;
    case 'team_meeting':
      if (value) {
        rules.value = {
          ...rules.value,
          meetingRoomId: '',
        };

        modalData.value.meetingRoomId = null;
      } else {
        rules.value = {
          ...rules.value,
          meetingRoomId: requiredRule(t),
        };

      }
      break;
    case 'private_meeting':
      if (value) {
        rules.value = {
          ...rules.value,
          coachIds: '',
          unemployedIds: '',
          meetingRoomId: '',
          locationId: '',
        };

        modalData.value.meetingRoomId = null;
      } else {
        rules.value = {
          ...rules.value,
          meetingRoomId: requiredRule(t),
        };

      }
      break;
    case 'others':
      if (value) {
        rules.value = {
          ...rules.value,
          coachIds: '',
          unemployedIds: '',
          meetingRoomId: '',
          locationId: '',
        };

        modalData.value.meetingRoomId = null;
      } else {
        rules.value = {
          ...rules.value,
          meetingRoomId: requiredRule(t),
        };

      }
      break;
  }

}

const handleStartDateChange = (date) => {
  modalData.value.startDate = date;
};

const handleEndDateChange = (date) => {
  modalData.value.endDate = date;
};

const fetchAllOptions = async (selectedStandort) => {
  try {
    const {data} = await calendarService.getOfficeData(selectedStandort);
    if (data?.data) {
      return data.data;
    } else {
      clearAllDropdowns();
    }
  } catch (error) {
    clearAllDropdowns();
    await ErrorToast(error.message || 'Failed to fetch options');
  }
};

const clearAllDropdowns = () => {
  dropdowns.value.meetingRoomId = [];
  dropdowns.value.coachesIds = [];
  dropdowns.value.unemployedIds = [];
};

const clearState = () => {
  modalData.value = {
    title: '',
    locationId: null,
    isRemote: false,
    meetingType: 'client_meeting',
    meetingRoomId: null,
    coachIds: [],
    unemployedIds: [],
    startDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
    endDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
  };
};

async function submitForm() {

  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    if (!modalData.value.id) {
      await calendarService.postCalendarMeeting(modalData.value);
    } else {
      await calendarService.updateCalendarMeeting(
          modalData.value,
          modalData.value.id
      );
    }

    showEventModal.value = false;

    await addEvents();

    SuccessToast(t('general.toasts.save_success'));
  } catch (e) {
    await ErrorToast(e);
  }

  // if (!modalData.value.id) {
  //   try {
  //     await calendarService.postCalendarMeeting(modalData.value);
  //     showEventModal.value = false;
  //
  //     await addEvents();
  //     SuccessToast(t('general.toasts.save_success'));
  //   } catch (e) {
  //     await ErrorToast(e);
  //   }
  //
  // } else {
  //   try {
  //     await calendarService.updateCalendarMeeting(modalData.value, modalData.value.id);
  //     showEventModal.value = false;
  //
  //     await addEvents();
  //     SuccessToast(t('general.toasts.save_success'));
  //   } catch (e) {
  //     await ErrorToast(e);
  //   }
  // }
}

watch(showEventModal, (newValue) => {
  showEventPopup.value = false;
  if (newValue) return;
  v$.value.$reset();
  clearState();
});

const initCalendar = () => {
  calendar.value = new Calendar(calendarRef.value, {
    defaultView: selectedView.value,
    locale: locale.value,
    scheduleView: ['time', 'allday'],
    week: {
      dayNames: [t('calendar.weekDays.sun'), t('calendar.weekDays.mon'), t('calendar.weekDays.tue'), t('calendar.weekDays.wed'), t('calendar.weekDays.thu'), t('calendar.weekDays.fri'), t('calendar.weekDays.sat')],
      startDayOfWeek: 1,
    },
    month: {
      dayNames: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      startDayOfWeek: 1,
    },
    taskView: ['label', 'time'],
    template: {
      time: (schedule) => `<span class="font-weight-bolder">${schedule.title}</span>`,
      month: {
        day: (task) => `<span>${task.title}</span>`,
        milestone: (milestone) => `<span>${milestone.title}</span>`,
      },
      week: {
        milestone: null,
      },
    },
    useFormPopup: false,
  });

  calendar.value.on('selectDateTime', (event) => {
    modalData.value.startDate = moment(event.start).format('YYYY-MM-DD HH:mm');
    modalData.value.endDate = moment(new Date(event.end)).format('YYYY-MM-DD HH:mm');
    showEventModal.value = true;
  });

  calendar.value.on('clickEvent', (event) => {
    const popupHeight = (196 / 2);
    const selectedMeeting = calendarsList.value.find(x => x.id === event.event.id);
    const coachNames = selectedMeeting?.coach?.map(coach => coach.value).join(', ') || '';
    const meetingRoom = selectedMeeting?.meetingRoom?.value || '';
    const unemployedNames = selectedMeeting?.unemployed?.map(coach => coach.value).join(', ') || '';

    const popupOffsetX = 20; // Shift a bit to the right
    const popupOffsetY = 10; // Shift a bit downward
    const rect = event.nativeEvent.srcElement.getBoundingClientRect();

    const widthSidebar = window.innerWidth > 1240 ? 264 : window.innerWidth > 768 ? 70 : 0;
    const heightMobileHeader = window.innerWidth > 1240 ? 0 : window.innerWidth > 0 ? 250 : 58;

    selectedEvent.value = {
      title: event.event.title,
      start: moment(event.event.start?.d?.d).format('YYYY-MM-DD HH:mm'),
      end: moment(event.event.end?.d?.d).format('YYYY-MM-DD HH:mm'),
      startFormated: moment(event.event.start?.d?.d).format('DD.MM.YYYY  HH:mm'),
      endFormated: moment(event.event.end?.d?.d).format('DD.MM.YYYY HH:mm'),
      location: event.event.location.value || 'N/A',
      organizer: event.organizer || 'N/A',
      id: event.event.id,
      backgroundColor: event.event.backgroundColor,
      // top: (event.nativeEvent.clientY + popupOffsetY) + 'px',
      top: (event.nativeEvent.pageY + popupOffsetY - heightMobileHeader) + 'px',

      //left: (event.nativeEvent.clientX + popupOffsetX) + 'px',
      //top: event.nativeEvent.clientY - popupHeight + 'px',
      // left: event.nativeEvent.srcElement.getBoundingClientRect().right + 3 - 580 + 'px',
      left: rect.left - widthSidebar + 'px',
      hisMeeting: selectedMeeting ? selectedMeeting.hisMeeting : false,
      coachNames: coachNames,
      meetingRoom: meetingRoom,
      unemployedNames: unemployedNames,
    };

    showEventPopup.value = true;
  });
};

const addEvents = async () => {
  await calendar.value.clear();

  if (selectedUser.value) {
    const getListParams = {
      startDate: formatDate(showedDateUpdated.value, 'YYYY-MM-DD'),
      rangeParameter: selectedView.value,
      myMeetings: checkboxes.value.personalTermin,
      remoteMeetings: checkboxes.value.remoteTermin,
      userId: selectedUser.value,
      locationIds: locationIds.value,
      meetingRoomIds: meetingRoomIds.value,
    };
    try {
      const {data} = await calendarService.getList(getListParams);
      calendarsList.value = data.data.calendarsList;

      const events = data.data.calendarsList?.map((item) => ({
        ...item,
        backgroundColor: item?.meetingRoom?.colorCode ?? item?.location?.colorCode,
        borderColor: item?.meetingRoom?.colorCode ?? item?.location?.colorCode,
        color: isColorDark(item?.meetingRoom?.colorCode ?? item?.location?.colorCode) ? 'white' : 'black',
        isReadOnly: true,
        calendarId: 'cal1',
        category: 'time',
      }));

      calendar.value.createEvents(events);
      calendar.value.render();

    } catch (error) {
      await ErrorToast(error);
    } finally {
      isLoaded.value = true;
    }
  }
};

const handleOfficeList = async (e, locationId, meetingId, officeMeetingIds) => {
  closeEventPopup();
  const {checked} = e.target;

  if (meetingId) {
    if (checked) {
      meetingRoomIds.value = [...meetingRoomIds.value, meetingId];
      if (!locationIds.value.find(item => item === locationId)) {
        locationIds.value = [...locationIds.value, locationId];
      }

    } else {
      meetingRoomIds.value = meetingRoomIds.value.filter((meetingRoomId) => meetingRoomId !== meetingId);
    }

    officeList.value = officeList.value.map((office) => office.id === locationId
        ? ({
          ...office,
          checked: checked ? true : office?.checked,
          meetingRooms: office.meetingRooms.map((meetingRoom) => (meetingRoom.id === meetingId ? {
            ...meetingRoom,
            checked: checked,
          } : meetingRoom)),
        })
        : office,
    );
  } else {
    if (checked) {
      locationIds.value = [...locationIds.value, locationId];
      const addIds = officeMeetingIds.map(item => item.id);
      meetingRoomIds.value = [...meetingRoomIds.value, ...addIds];
    } else {
      locationIds.value = locationIds.value.filter((office) => office !== locationId);
      const idsToRemove = officeMeetingIds.map(item => item.id);
      meetingRoomIds.value = meetingRoomIds.value.filter(value => !idsToRemove.includes(value));
    }

    officeList.value = officeList.value.map((office) => office.id === locationId
        ? ({
          ...office,
          checked: checked,
          meetingRooms: office.meetingRooms.map((meetingRoom) => ({...meetingRoom, checked: checked})),
        })
        : office,
    );
  }

  await addEvents();
};

const handleCheckboxesOptions = (e) => {
  closeEventPopup();

  const {name, checked} = e.target;
  if (name === 'allLocations') {

    officeList.value = officeList.value.map((office) => {
      return {
        ...office,
        checked: checked,
        meetingRooms: office?.meetingRooms?.map((meeting) => ({...meeting, checked: checked})),
      };
    });
    if (checked) {

      locationIds.value = officeListBackup.value.map((office) => office.value);

      meetingRoomIds.value = Array.from(
          new Set(
              officeListBackup.value
                  .flatMap((office) => office?.meetingRooms?.map((meeting) => meeting?.id)),
          ),
      );
    } else {
      locationIds.value = [];
      meetingRoomIds.value = [];
    }
  }
  checkboxes.value = {...checkboxes.value, [name]: checked};
};

watch(checkboxes, async (newValue, oldValue) => {
  if (newValue !== oldValue) {
    await addEvents();
  }
});

const changeView = (view) => {
  if (calendar.value) {
    calendar.value.changeView(view);
    selectedView.value = view;
    showDropdown.value = false;
    changeShowedDate();
  }
};

watch(showedDate, async (newValue, oldValue) => {
  if (newValue !== oldValue) {
    await addEvents();
  }
});

watch(selectedUser, async (newValue, oldValue) => {
  if (newValue !== oldValue) {
    await addEvents(newValue);
    await getOfficeList();
  }
  showEventPopup.value = false;
});

const movePrev = () => {
  isLoaded.value = false;
  if (selectedView.value === 'month' && calendar.value) {
    calendar.value.prev();
    showedDate.value = moment(showedDate.value).subtract(1, 'months').startOf('month').toDate();
  } else if (selectedView.value === 'week' && calendar.value) {
    calendar.value.prev();
    showedDate.value = moment(showedDate.value).subtract(1, 'weeks').startOf('isoWeek').toDate();
  } else if (selectedView.value === 'day' && calendar.value) {
    calendar.value.prev();
    showedDate.value = moment(showedDate.value).subtract(1, 'days').startOf('day').toDate();
  }
  showEventPopup.value = false;
};

const moveNext = () => {
  isLoaded.value = false;
  if (selectedView.value === 'month' && calendar.value) {
    calendar.value.next();
    showedDate.value = moment(showedDate.value).add(1, 'months').startOf('month').toDate();
  } else if (selectedView.value === 'week' && calendar.value) {
    calendar.value.next();
    showedDate.value = moment(showedDate.value).add(1, 'weeks').startOf('isoWeek').toDate();
  } else if (selectedView.value === 'day' && calendar.value) {
    calendar.value.next();
    showedDate.value = moment(showedDate.value).add(1, 'days').startOf('day').toDate();
  }
  showEventPopup.value = false;
};

const setShowedDate = () => {
  changeShowedDate();
  calendar.value.setDate(showedDate.value);
};

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const selectedOption = computed(() => {
  return CalendarViewOptions.value.find(option => option.value === selectedView.value) || {};
});

const selectedTitle = computed(() => {
  return selectedOption.value.title || 'Select view';
});

const showedDateUpdated = computed(() => {
  return showedDate.value;
});

const selectedClass = computed(() => {
  return selectedOption.value.class;
});

const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    showDropdown.value = false;
  }

  if (eventPopupRef.value && !eventPopupRef.value.contains(event.target) && showEventPopup.value) {
    showEventPopup.value === false;
  }
};

const closeEventPopup = () => {
  showEventPopup.value = false;
};

const editEvent = async () => {
  try {
    const {data} = await calendarService.getSingleMeeting(selectedEvent.value.id);

    modalData.value = {
      locationId: data.data.locationId,
      meetingType: data.data.meetingType,
      isRemote: data.data.isRemote,
    };

    await updateLocation(data.data.locationId);

    if (data.data.meetingType === 'private_meeting' || data.data.meetingType === 'others') {
      dropdowns.value.coachesIds = [data.data.coachIds];
      modalData.value.coachIds = [data.data.coachIds.value];
      modalData.value = {
        ...modalData.value,
        title: data.data.title,
        meetingRoomId: data.data.meetingRoomId,
        isRemote: data.data.isRemote,
        unemployedIds: data.data.unemployedIds,
        endDate: data.data.endDate,
        startDate: data.data.startDate,
        id: data.data.id,
      };
    } else {
      modalData.value = {
        ...modalData.value,
        title: data.data.title,
        meetingRoomId: data.data.meetingRoomId,
        coachIds: data.data.coachIds,
        isRemote: data.data.isRemote,
        unemployedIds: data.data.unemployedIds,
        endDate: data.data.endDate,
        startDate: data.data.startDate,
        id: data.data.id,
      };
    }

    showEventModal.value = true;
  } catch (e) {
    await ErrorToast(e);
  }
};

const deleteEvent = async () => {
  try {
    await calendarService.deleteMeeting(selectedEvent.value?.id);
    await addEvents();
    showDeleteEvent.value = false;
    closeEventPopup();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
};

const showDeleteEventModal = () => {
  showDeleteEvent.value = true;
};

const changeShowedDate = () => {
  showEventPopup.value = false;
  if (selectedView.value === 'week') {
    showedDate.value = moment(showedDate.value).day(1).startOf('day').toDate();
    calendar.value.setDate(showedDate.value);
  } else if (selectedView.value === 'month') {
    showedDate.value = moment(showedDate.value).startOf('month').toDate();
    calendar.value.setDate(showedDate.value);
  } else {
    showedDate.value = new Date();
    calendar.value.setDate(showedDate.value);
  }
};

const debouncedSearch = debounce(async (query) => {
  closeEventPopup();
  const {data: officeListResponse} = await calendarService.getOfficeList(selectedUser.value, query);
  officeList.value = officeListResponse.data.offices.map((office) => {
    return {
      ...office,
      checked: locationIds.value.includes(office.id),
      meetingRooms: office?.meetingRooms.map((meeting) => ({
        ...meeting,
        checked: meetingRoomIds.value.includes(meeting?.id),
      })),
    };
  });
}, 300);

const handleInputOffices = (event) => {
  debouncedSearch(event.target.value);
};

async function getOfficeList() {
  closeEventPopup();

  const {data: officeListResponse} = await calendarService.getOfficeList(selectedUser.value, '');
  const listUpdated = officeListResponse.data.offices.map((office) => {
    return {
      ...office,
      checked: true,
      meetingRooms: office?.meetingRooms.map((meeting) => ({...meeting, checked: checkboxes.value.allLocations})),
    };
  });

  officeList.value = listUpdated;
  officeListBackup.value = listUpdated;

  locationIds.value = officeListResponse.data.offices.map((office) => office.id);
  meetingRoomIds.value = Array.from(
      new Set(officeListResponse.data.offices.flatMap((office) => office?.meetingRooms.map((meeting) => meeting?.id))),
  );
  await addEvents();

  officeListBackup.value = listUpdated.map(item => ({
    ...item,
    label: `${item.name}`,
    value: item?.id,
  }));
}

onMounted(async () => {
  showEventPopup.value = false;
  initCalendar();
  document.addEventListener('click', handleClickOutside, true);
  changeShowedDate();

  try {
    const {data} = await calendarService.getUserDropdown();
    userDropdown.value = data.data.map(item => ({
      label: `${item.firstName} ${item.lastName}`,
      value: item?.id,
    }));

    await getOfficeList();

  } catch (error) {
    await ErrorToast(error);
  }

  isLoaded.value = true;
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside, true);
});

</script>

<style>
.calendar {
  /* height: calc(100% - 61px); */
  height: 940px;
  overflow: auto;
}

.calendar .toastui-calendar-layout {
  width: 100%;
  min-width: 700px;
}

.view-selector {
  margin-bottom: 15px;
}

.dropdown .btn {
  min-width: 100px;
}

.dropdown-menu {
  display: block;
}

.dropdown-item {
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  background-size: contain;
  background-position: center;
}

.event-popup {
  position: absolute;
  background: white;
  z-index: 1000;
  min-width: max-content;
}

@media screen and (max-width: 568px) {
  .event-popup {
    left: 14px !important;
  }
}

input[type=checkbox].tui-full-calendar-checkbox-round + span {
  display: inline-block;
  cursor: pointer;
  width: 14px;
  height: 14px;
  line-height: 14px;
  vertical-align: middle;
  margin-right: 8px;
  border-radius: 8px;
  border: 2px solid;
  background: transparent;
}

.toastui-calendar-allday,
.toastui-calendar-allday + div,
.toastui-calendar-task,
.toastui-calendar-task + div,
.toastui-calendar-milestone,
.toastui-calendar-milestone + div {
  display: none;
}

.toastui-calendar-panel.toastui-calendar-time {
  height: calc(100% - 44px) !important;
}

.tui-full-calendar-popup-container {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .1);
  background-color: #fff;
  border: 1px solid #d5d5d5;
  padding: 18px;
  padding-bottom: 12px;
  border-radius: 2px;
}

.event-popup .tui-full-calendar-popup-top-line {
  height: 4px;
}

.event-popup h6 {
  font-size: 16px;
  font-weight: 700;
}

.event-popup p {
  font-size: 12px;
  color: #3e4b5b;
}

.tui-full-calendar-arrow-left .tui-full-calendar-popup-arrow-border {
  border: 8px solid transparent;
  border-right-color: white;
  border-left: none;
  top: calc(50% - 8px);
  transform: rotate(180deg);
  right: -7px;
  position: absolute;
}

.toastui-calendar-weekday .toastui-calendar-grid-selection {
  position: absolute;
  z-index: -1;
}

.toastui-calendar-column .toastui-calendar-grid-selection {
  position: absolute;
  z-index: -1;
}
</style>
